import * as _ from "lodash";
import * as angular from "angular";
import { DashboardWidget } from "./dashboard-widget.model";

export class Dashboard {
    public id: number = null;
    public name: string = null;
    public uid: number = null;
    public filter: any = null;
    public access: string = "public";
    public widgets: DashboardWidget[] = [];
    public timestamp: any = null;
    public location: string = null;
    public creator: number = null;
    public lastupdater: number = null;
    public creationtimestamp: any = null;
    public lastmodifiedtimestamp: any = null;
    public hasEditPermission: boolean = false;

    constructor(data?: any) {
        this.setData(data);
    }

    setData(data: any): void {
        _.merge(this, data);

        for (let i = 0; i < this.widgets.length; i++) {
            this.widgets[i] = new DashboardWidget(this.widgets[i]);
        }
    }
    clear(): void {
        this.widgets = [];
    }

    referenceName(): string {
        return this.location == "user" ? "User Dashboard " : "Dashboard";
    }
}
